export const FETCHING_BOOKINGS = "FETCHING.BOOKINGS";
export const FETCHING_RENTAL_PRICE = "FETCHING.RENTAL_PRICE";
export const DELETING_BOOKING = "DELETING.BOOKING";
export const FETCHED_BOOKINGS = "FETCHED.BOOKINGS";
export const FETCHED_RENTAL_PRICE = "FETCHED.RENTAL_PRICE";
export const ERROR_FETCHING_BOOKINGS = "ERROR.FETCHING_BOOKINGS";
export const ERROR_FETCHING_RENTAL_PRICE = "ERROR.FETCHING_RENTAL_PRICE";
export const ADDING_BOOKING = "ADDING.BOOKING";
export const ADDED_BOOKING = "ADDED.BOOKING";
export const DELETED_BOOKING = "DELETED.BOOKING";
export const ERROR_ADD_BOOKING = "ERROR.ADD_BOOKING";
export const ERROR_DELETING_BOOKING = "ERROR.DELETING_BOOKING";